import script from "./DoctorSchedule.vue?vue&type=script&setup=true&lang=js"
export * from "./DoctorSchedule.vue?vue&type=script&setup=true&lang=js"

import "./DoctorSchedule.vue?vue&type=style&index=0&id=37acb171&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37acb171"]])

export default __exports__